import type { IRoute } from '@/router/helpers'
import { BasicLayout, ContentLayout, ProfileLayout } from '@/layouts'

const route: IRoute = {
  path: 'profile',
  Component: ContentLayout,
  children: [
    {
      path: '',
      Component: ProfileLayout,
      children: [
        {
          path: '',
          Component: lazy(() => import('@/views/profile/home')),
          meta: { title: '个人中心' },
        },
        {
          path: 'order',
          Component: lazy(() => import('@/views/profile/order')),
          meta: { title: '我的契约' },
        },
        {
          path: 'undertake',
          Component: lazy(() => import('@/views/profile/undertake')),
          meta: { title: '我的承办' },
        },
        {
          path: 'addr',
          Component: lazy(() => import('@/views/profile/addr')),
          meta: { title: '我的收货地址' },
        },
        {
          path: 'card',
          Component: lazy(() => import('@/views/profile/card')),
          meta: { title: '我的银行卡' },
        },
        {
          path: 'anns',
          Component: lazy(() => import('@/views/profile/anns')),
          meta: { title: '公告' },
        },
      ],
    },
    {
      path: 'anns/:id',
      Component: lazy(() => import('@/views/profile/anns/detail')),
      meta: { title: '详情' },
    },
    {
      path: 'order',
      Component: BasicLayout,
      children: [
        {
          path: ':id',
          Component: lazy(() => import('@/views/profile/order/detail')),
          meta: { title: '契约详情' },
        },
        {
          path: 'refund/:id',
          Component: lazy(() => import('@/views/profile/order/refund')),
        },
        {
          path: 'change/:id',
          Component: lazy(() => import('@/views/profile/order/change')),
        },
        {
          path: 'transfer/:id',
          Component: lazy(() => import('@/views/profile/order/transfer')),
        },
        {
          path: 'product/:id',
          Component: lazy(() => import('@/views/profile/order/product')),
        },
        {
          path: 'bindcard/:id',
          Component: lazy(() => import('@/views/profile/order/bind-card')),
        },
        {
          path: 'error/:id',
          Component: lazy(() => import('@/views/profile/order/error')),
        },
      ],
    },
    {
      path: 'goods/:id',
      Component: lazy(() => import('@/views/profile/order/goods-detail')),
    },
    {
      path: 'join',
      Component: lazy(() => import('@/views/profile/join')),
      meta: { title: '申请代理商' },
    },
  ],
}

export default route
